import { HvFormStatus } from "@hitachivantara/uikit-react-core";
import { FormikErrors, FormikTouched, getIn } from "formik";

export const parseStatus = (
  field: string,
  serverSideErrors: FormikErrors<unknown>,
  errors: FormikErrors<unknown>,
  touched: FormikTouched<unknown>
): HvFormStatus =>
  getIn(serverSideErrors, field) ||
  (getIn(errors, field) && getIn(touched, field))
    ? "invalid"
    : "valid";

export const parseStatusMessage = (
  field: string,
  serverSideErrors: FormikErrors<unknown>,
  errors: FormikErrors<unknown>,
  touched: FormikTouched<unknown>
): string => {
  if (getIn(serverSideErrors, field)) {
    return getIn(serverSideErrors, field);
  }

  return getIn(errors, field) && getIn(touched, field)
    ? getIn(errors, field)
    : "";
};
